export default __webpack_public_path__ + "static/media/PAYW-Pro-Light.56d568cc.otf";